import { memo } from 'react';

import { UploadIcon } from '@air/design-icons';
import {
  ContentCollectionSidebar,
  ContentCollectionSidebarHeader,
  ContentCollectionSidebarInstructions,
  ContentCollectionSidebarTerms,
} from '@air/feature-content-collection/ui';
import { useBreakpointsContext } from '@air/provider-media-query';

import { ContentCollectionAutoSubmitUploadsTrackingPanel } from '~/components/ContentCollection/ContentCollectionAutoSubmitUploadsTrackingPanel';
import { ContentCollectionUploadMoreButton } from '~/components/ContentCollection/ContentCollectionUploadMoreButton';
import { useContentCollectionAutoSubmitBatcher } from '~/components/ContentCollection/hooks/useContentCollectionAutoSubmitBatcher';
import { Routes } from '~/constants/routes';

export const ContentCollectionAutoSubmitView = memo(() => {
  const { isAboveMediumScreen } = useBreakpointsContext();
  useContentCollectionAutoSubmitBatcher();

  return (
    <div
      data-testid="CONTENT_COLLECTION_AUTO_SUBMIT_VIEW"
      className="flex size-full flex-col justify-center overflow-y-auto md:flex-row md:overflow-y-hidden"
    >
      <ContentCollectionSidebar className="hidden md:block">
        <ContentCollectionSidebarHeader />
        <ContentCollectionSidebarInstructions />
        <ContentCollectionSidebarTerms routes={{ terms: Routes.marketing.terms, privacy: Routes.marketing.privacy }} />
      </ContentCollectionSidebar>
      <div className="relative flex h-full w-full flex-col items-center justify-center p-4">
        <div className="flex h-full w-full flex-1 items-center justify-center px-2">
          <ContentCollectionAutoSubmitUploadsTrackingPanel />
        </div>
        {isAboveMediumScreen ? (
          <ContentCollectionUploadMoreButton prefix={<UploadIcon size="md" />}>
            Upload more
          </ContentCollectionUploadMoreButton>
        ) : (
          <ContentCollectionUploadMoreButton
            prefix={<UploadIcon size="md" />}
            appearance="filled"
            color="blue"
            className="w-full text-white"
            size="extra-large"
          >
            Upload more files
          </ContentCollectionUploadMoreButton>
        )}
      </div>
    </div>
  );
});

ContentCollectionAutoSubmitView.displayName = 'ContentCollectionAutoSubmitView';
